import { type ReactNode } from 'react';
import { Spinner } from '@fluentui/react-components';
import { useAuthLoadingStyles } from './AuthLoading.styles';

export function AuthLoading(): ReactNode {
  const styles = useAuthLoadingStyles();

  return (
    <div className={styles.container} role="status" aria-live="polite" aria-busy="true">
      <Spinner size="large" />
    </div>
  );
}
